export function money(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '–';
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function num(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '–';
  return n.toLocaleString();
}

export function pct(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '–';
  return `${n}%`;
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '–';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '–';
  const diffMs = Math.max(0, Date.now() - then);
  const min = Math.floor(diffMs / 60_000);
  if (min < 1)  return 'just now';
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24)  return `${hr}h ago`;
  const d = Math.floor(hr / 24);
  return `${d}d ago`;
}
